"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var papaparse_1 = __importDefault(require("papaparse"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var BuildFlow_1 = require("Project/Actions/BluePrint/BuildFlow/BuildFlow");
var BLUEPRINT_BATCH_LIMIT = 500;
var CsvImport = (function (_super) {
    __extends(CsvImport, _super);
    function CsvImport() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.onFileChange = function (event) {
            var onImported = _this.props.onImported;
            if (!event.target.files) {
                return;
            }
            var file = event.target.files[0];
            papaparse_1.default.parse(file, {
                header: true,
                skipEmptyLines: true,
                error: function (err) {
                    var errorHeader = "Unfortunately there was an error parsing that CSV file:";
                    onImported(BuildFlow_1.BlueprintDataSource.Csv, null, "".concat(errorHeader, " ").concat(err.message));
                },
                complete: function (results) {
                    var data = results.data;
                    if (data.length && data.length <= BLUEPRINT_BATCH_LIMIT) {
                        onImported(BuildFlow_1.BlueprintDataSource.Csv, data);
                    }
                    else if (data.length && data.length > BLUEPRINT_BATCH_LIMIT) {
                        var tooManyRowsError = "You can only create ".concat(BLUEPRINT_BATCH_LIMIT, " projects at once. ") +
                            "The selected CSV file has more than ".concat(BLUEPRINT_BATCH_LIMIT, " rows. Please try again with fewer rows.");
                        onImported(BuildFlow_1.BlueprintDataSource.Csv, null, tooManyRowsError);
                    }
                    else {
                        onImported(BuildFlow_1.BlueprintDataSource.Csv, null, "Sorry, we could not find any valid data in that file!");
                    }
                },
            });
        };
        return _this;
    }
    CsvImport.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "import csv-import" },
            react_1.default.createElement("div", { className: "description" },
                react_1.default.createElement("h4", { className: "title" }, "Spreadsheet CSV"),
                react_1.default.createElement("p", null, "Import data from a CSV (comma-separated values) file.")),
            react_1.default.createElement("div", { className: "action" },
                react_1.default.createElement("form", null,
                    react_1.default.createElement("label", { className: "styled-file-input secondary-action-button" },
                        react_1.default.createElement("input", { type: "file", onChange: this.onFileChange }),
                        react_1.default.createElement("span", { className: "text" }, "Upload CSV"))))));
    };
    CsvImport = __decorate([
        mobx_react_1.observer
    ], CsvImport);
    return CsvImport;
}(react_1.default.Component));
exports.default = CsvImport;
